
import React, { Suspense } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import Home from './pages/home';

function App() {
  return (
    <BrowserRouter>
      <div className='w-full min-h-screen lg:p-8 bg-white flex flex-row items-stretch justify-start lg:overflow-y-clip select-none'>
        <Suspense fallback={<div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>...please wait</div>}></Suspense>
        <Routes>
          <Route path='/' element={<Home />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
